import { COLORS } from '../themeConf';
export const sentryReportStyle = {
    '.sentry-error-embed-wrapper .form-submit button[type="submit"]': {
        backgroundColor: `${COLORS.primary.main} !important`,
        border: 'none !important',
        outline: 'none !important',
    },
    '.sentry-error-embed-wrapper .form-submit button[type="submit"]:hover': {
        backgroundColor: `${COLORS.primary.dark} !important`,
    },
    '.sentry-error-embed-wrapper .form-submit button[type="submit"]:active': {
        backgroundColor: `${COLORS.primary.main} !important`,
    },
};
//# sourceMappingURL=reportStyle.js.map